import { configureStore } from '@reduxjs/toolkit'
import appDataReducer from "../redux/appDataSlice";
export default configureStore({
    reducer: {
        appData: appDataReducer,
    },
})

